module.exports = __webpack_public_path__ + "static/img/activity.b4618ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity.png
// module id = Nkfs
// module chunks = 1